import React from 'react';

export const AzureDevopsSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="#0078D4"
			/>
			<path
				d="M26 9.74571V21.9057L21 26L13.25 23.1786V25.9757L8.86286 20.2429L21.65 21.2429V10.2929L26 9.74571ZM21.7371 10.3571L14.5629 6V8.85857L7.97429 10.7943L6 13.3286V19.0843L8.82571 20.3314V12.9557L21.7371 10.3571Z"
				fill="white"
			/>
		</svg>
	);
};
